var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.16,
    height: 44.195,
    viewBox: "0 0 44.16 44.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(295.72 644.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M-274.942-599.96c-.837-.113-1.682-.187-2.51-.346a21.842,21.842,0,0,1-15.675-11.4,20.66,20.66,0,0,1-2.58-10.849,21.675,21.675,0,0,1,8.166-16.582,21.287,21.287,0,0,1,11.678-4.851c1.379-.141,2.775-.112,4.206-.162-.154,1.527-.3,2.964-.45,4.466-6.252-.32-11.51,1.747-15.5,6.625a16.8,16.8,0,0,0-3.859,12.438,17.682,17.682,0,0,0,17.6,16.245,17.173,17.173,0,0,0,13.107-5.9,17.779,17.779,0,0,0,4.5-13.727l4.447-.451.234,1.048v2.673c-.035.311-.072.621-.106.932a21.766,21.766,0,0,1-4.75,11.53A21.764,21.764,0,0,1-269.89-600.3c-.816.146-1.643.227-2.465.339Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M15.412,12.314,7.545,4.4h5.621V0H0V13.18H4.361v-5.7l7.946,7.953c.944-.944,1.844-1.848,2.748-2.747a4.333,4.333,0,0,1,.358-.29Z",
    transform: "translate(-251.56 -644.12) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M-107.5-551.1h6.581v4.424h-.474c-3.347,0-6.693-.007-10.04.009-.4,0-.5-.106-.5-.5q.02-7.239,0-14.478c0-.4.106-.511.5-.5,1.148.026,2.3.028,3.447,0,.413-.011.494.131.493.512-.014,3.318-.008,6.636-.008,9.954Z",
    transform: "translate(-163.934 -73.143)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/Out.be5e16523f2ff69ef352b0d4fe9b5c09.svg";
export { ForwardRef as ReactComponent };